import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useNotification } from "../../hooks/useNotification";
import { createNewPost, deletePost, editPost, getPost, getPosts } from "../../api/postsAPI";
import Search from "../../components/Search/Search";
import {
    Box,
    Button,
    ButtonProps,
    Checkbox,
    FormControlLabel,
    Grid,
    ImageList,
    ImageListItem,
    Link,
    Pagination,
    Paper,
    styled,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
} from "@mui/material";
import { MODAL_TYPE } from "../../constants/common";
import Modal from "../../components/UI/Modal/Modal";
import CustomSnackbar from "../../components/UI/CustomSnackbar";
import Loader from "../../components/Loader/Loader";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { PostData, PostDataCreate, PostDataEdit } from "../../types/api/post";
import PhotoUpload from "../../components/PhotoUpload/PhotoUpload";
import TabPanel from "../../components/TabPanel/TabPanel";
import { getDateFormat } from "../../utils/getDateFormat";
import { BASE_IMG_URL } from "../../constants/mainAPI";
import { LinkBehavior } from "../../components/LinkBehavior/LinkBehavior";
import { Photo } from "../../types/api/photo";
import { TagNames } from "../../constants/tags";

const ColorButton = styled(Button)<ButtonProps>(({ theme }) => ({
    color: "rgb(244, 115, 33)",
    "&:hover": {
        backgroundColor: "rgba(210, 185, 25, 0.04)",
    },
    "&:active": {
        boxShadow: "none",
    },
}));

const PostsPage = () => {
    const { id } = useParams();
    const isOwner =
        localStorage.getItem("employee_type") == "16" &&
        localStorage.getItem("employee_center_id") == localStorage.getItem("current_center_id");
    const [load, setLoad] = useState(false);
    const [pagination, setPagination] = useState({
        current_page: 1,
        last_page: 1,
    });
    const [tab, setTab] = React.useState(1);
    const [posts, setPosts] = useState<Array<PostData>>();
    const [postId, setPostId] = useState(0);
    const [deletePostId, setDeletePostId] = useState(0);
    const [query, setQuery] = useState({});
    const { setNotification, setOpenSnackbar, notification, openSnackbar } = useNotification();
    const [showModal, setShowModal] = useState<boolean>(false);
    const [currentModalType, setCurrentModalType] = useState("edit");
    const closeModal = () => {
        setShowModal(false);
    };

    const fetchPosts = (query?: any) => {
        setLoad(true);
        getPosts(
            id,
            ({ data, last_page, current_page }) => {
                setPosts(data);
                setPagination({ ...pagination, last_page: last_page, current_page: current_page });
                setLoad(false);
            },
            err => {
                setNotification({
                    severity: "error",
                    message: err.message || "",
                });
                setLoad(false);
            },
            { page: pagination.current_page, ...query },
        );
    };

    const editResetFormData = (data: any) => {
        editForm.reset({
            ...data,
            center: {},
            text: data.text || "",
            url: data.url || "",
            date: data.date?.slice(0, 10).replace(/-/g, "/"),
            date_end: data.date_end?.slice(0, 10).replace(/-/g, "/") || "",
        });
    };

    const getPostData = (postId: number) => {
        setLoad(true);
        getPost(
            id,
            postId,
            ({ data }) => {
                setLoad(false);
                setShowModal(true);
                editResetFormData(data);
            },
            err => {
                setLoad(false);
                setNotification({
                    severity: "error",
                    message: err.message || "",
                });
            },
        );
    };

    const createForm = useForm<PostDataCreate>({
        defaultValues: {
            title: "",
            url: "",
            date: "",
            photos: [],
            documents: [],
            text: "",
            date_end: "",
        },
        shouldUnregister: true,
    });
    const editForm = useForm<PostDataEdit>({
        defaultValues: {
            title: "",
            url: "",
            date: "",
            photos: [],
            documents: [],
            text: "",
            date_end: "",
        },
        shouldUnregister: true,
    });

    // const checkboxForm = useForm<PostDataEdit>();

    const create: SubmitHandler<PostDataCreate> = (data: any) => {
        setLoad(true);
        if (tab === 0) {
            data["tags[]"] = TagNames.OPEN_CENTER;
        }
        if (!data.url) {
            delete data.url;
        }
        if (!data.photos.length) {
            delete data.photos;
        }
        createNewPost(
            id,
            data,
            () => {
                fetchPosts(query);
                setNotification({
                    severity: "success",
                    message: "Пост добавлен успешно",
                });
                setOpenSnackbar(true);
                setLoad(false);
                closeModal();
            },
            err => {
                setNotification({
                    severity: "error",
                    message: err.message || "",
                });
                setOpenSnackbar(true);
                setLoad(false);
                Object.keys(err.errors).forEach((fieldName: any) => {
                    createForm.setError(fieldName, {
                        type: "custom",
                        message: err.errors[fieldName][0],
                    });
                });
            },
        );
    };
    const edit: SubmitHandler<PostDataEdit> = (data: any) => {
        setLoad(true);
        if (!data.url) {
            delete data.url;
        }
        if (tab === 0) {
            data.tags = [TagNames.OPEN_CENTER];
        }
        editPost(
            id,
            postId,
            data,
            ({ data }) => {
                editResetFormData(data);
                fetchPosts(query);
                setNotification({
                    severity: "success",
                    message: "Пост изменен успешно",
                });
                setOpenSnackbar(true);
                setLoad(false);
                closeModal();
            },
            err => {
                setNotification({
                    severity: "error",
                    message: err.message || "",
                });
                setLoad(false);
                setOpenSnackbar(true);
                Object.keys(err.errors).forEach((fieldName: any) => {
                    editForm.setError(fieldName, {
                        type: "custom",
                        message: err.errors[fieldName][0],
                    });
                });
            },
        );
    };
    const del: SubmitHandler<any> = () => {
        setLoad(true);
        deletePost(
            id,
            deletePostId,
            () => {
                fetchPosts(query);
                setNotification({
                    severity: "success",
                    message: "Пост удален успешно",
                });
                setOpenSnackbar(true);
                setLoad(false);
            },
            err => {
                setNotification({
                    severity: "error",
                    message: err.message || "",
                });
                setOpenSnackbar(true);
                setLoad(false);
            },
        );
        closeModal();
    };

    const createContent = (
        <Box
            component="form"
            sx={{
                "& .MuiTextField-root": { my: 1 },
            }}
            noValidate
            autoComplete="off">
            <Controller
                defaultValue={""}
                name="title"
                control={createForm.control}
                rules={{
                    required: true,
                    maxLength: {
                        value: 120,
                        message: "Максимальная длина 120 символов",
                    },
                }}
                render={({ field, fieldState }) => (
                    <TextField
                        {...field}
                        size={"small"}
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                        label={"Наименование"}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                    />
                )}
            />
            <Controller
                defaultValue={""}
                name="url"
                control={createForm.control}
                render={({ field, fieldState }) => (
                    <TextField
                        {...field}
                        size={"small"}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        fullWidth
                        label={"Cсылка подробной информации"}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                    />
                )}
            />
            <Controller
                defaultValue={""}
                name="text"
                control={createForm.control}
                render={({ field, fieldState }) => (
                    <TextField
                        {...field}
                        size={"small"}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        fullWidth
                        label={"Подробный текст"}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                    />
                )}
            />
            <Controller
                defaultValue={""}
                name="date"
                control={createForm.control}
                render={({ field: { onChange, value, ...field }, fieldState }) => (
                    <TextField
                        {...field}
                        size={"small"}
                        type="date"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        fullWidth
                        label="Дата мероприятия"
                        onChange={(e: any) => {
                            onChange(e.target.value.replace(/-/g, "/"));
                        }}
                        value={value?.replace(/\//g, "-")}
                        autoComplete="off"
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                    />
                )}
            />
            <Controller
                defaultValue={""}
                name="date_end"
                control={createForm.control}
                render={({ field: { onChange, value, ...field }, fieldState }) => (
                    <TextField
                        {...field}
                        size={"small"}
                        type="date"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        fullWidth
                        label="Дата окончания мероприятия"
                        onChange={(e: any) => {
                            onChange(e.target.value.replace(/-/g, "/"));
                        }}
                        value={value?.replace(/\//g, "-")}
                        autoComplete="off"
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                    />
                )}
            />
            <Controller
                defaultValue={[]}
                name="photos"
                control={createForm.control}
                render={({ field: { value }, fieldState, formState: { errors } }) => {
                    return (
                        <PhotoUpload
                            formError={errors?.photos?.type === "required"}
                            error={fieldState.error}
                            field={{ photos: value }}
                            setValue={createForm.setValue}
                        />
                    );
                }}
            />
        </Box>
    );

    const editContent = (
        <Box
            component="form"
            sx={{
                "& .MuiTextField-root": { my: 1 },
            }}
            noValidate
            autoComplete="off">
            <Controller
                defaultValue={""}
                name="title"
                control={editForm.control}
                rules={{
                    required: true,
                    maxLength: {
                        value: 120,
                        message: "Максимальная длина 120 символов",
                    },
                }}
                render={({ field, fieldState }) => (
                    <TextField
                        {...field}
                        size={"small"}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        fullWidth
                        label={"Наименование"}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                    />
                )}
            />
            <Controller
                defaultValue={""}
                name="url"
                control={editForm.control}
                render={({ field, fieldState }) => (
                    <TextField
                        {...field}
                        size={"small"}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        fullWidth
                        label={"Ссылка подробной информации"}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                    />
                )}
            />
            <Controller
                defaultValue={""}
                name="text"
                control={editForm.control}
                render={({ field, fieldState }) => (
                    <TextField
                        {...field}
                        size={"small"}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        fullWidth
                        label={"Подробный текст"}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                    />
                )}
            />
            <Controller
                defaultValue={""}
                name="date"
                control={editForm.control}
                render={({ field: { onChange, value, ...field }, fieldState }) => (
                    <TextField
                        {...field}
                        size={"small"}
                        type="date"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        fullWidth
                        label="Дата мероприятия"
                        onChange={(e: any) => {
                            onChange(e.target.value.replace(/-/g, "/"));
                        }}
                        value={value?.replace(/\//g, "-")}
                        autoComplete="off"
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                    />
                )}
            />
            <Controller
                defaultValue={""}
                name="date_end"
                control={editForm.control}
                render={({ field: { onChange, value, ...field }, fieldState }) => (
                    <TextField
                        {...field}
                        size={"small"}
                        type="date"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        fullWidth
                        label="Дата окончания мероприятия"
                        onChange={(e: any) => {
                            onChange(e.target.value.replace(/-/g, "/"));
                        }}
                        value={value?.replace(/\//g, "-")}
                        autoComplete="off"
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                    />
                )}
            />
            <FormControlLabel
                control={
                    <Controller
                        name="state"
                        control={editForm.control}
                        render={({ field }) => (
                            <Checkbox
                                onChange={e => field.onChange(Number(e.target.checked))}
                                checked={!!field.value}
                            />
                        )}
                    />
                }
                label="Отметка о проведении"
            />

            <Controller
                defaultValue={[]}
                name="photos"
                control={editForm.control}
                render={({ field: { value }, fieldState }) => {
                    return (
                        <PhotoUpload error={fieldState.error} field={{ photos: value }} setValue={editForm.setValue} />
                    );
                }}
            />
        </Box>
    );
    const deleteContent = <div>Вы уверены, что хотите удалить данные о посте?</div>;

    const modalType = {
        [MODAL_TYPE.create]: {
            title: "Создание мероприятия",
            onSubmit: createForm.handleSubmit(create),
            content: createContent,
        },
        [MODAL_TYPE.edit]: {
            title: "Редактирование мероприятия",
            onSubmit: editForm.handleSubmit(edit),
            content: editContent,
        },
        [MODAL_TYPE.delete]: {
            title: "Удаление мероприятия",
            onSubmit: del,
            content: deleteContent,
        },
    };

    useEffect(() => {
        setLoad(true);
        fetchPosts(query);
    }, [pagination.current_page, query]);

    useEffect(() => {
        postId && getPostData(postId);
    }, [postId]);

    return (
        <>
            <div className={"container"}>
                <div className={"pageHeader"}>Мероприятия</div>
                <Search
                    clearHandler={value => {
                        setQuery({ q: value });
                    }}
                    searchHandler={value => {
                        setQuery({ q: value });
                    }}
                />
                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} sx={{ mb: 1 }}>
                    <Grid item xs={12}>
                        <ColorButton
                            fullWidth
                            sx={{ backgroundColor: tab === 0 ? "rgba(210, 185, 25, 0.04)" : "" }}
                            onClick={() => {
                                setQuery({ "tags[]": TagNames.OPEN_CENTER });
                                setTab(0);
                            }}>
                            Открытие центра
                        </ColorButton>
                    </Grid>
                    <Grid item xs={6}>
                        <ColorButton
                            fullWidth
                            sx={{ backgroundColor: tab === 1 ? "rgba(210, 185, 25, 0.04)" : "" }}
                            onClick={() => {
                                setQuery({});
                                setTab(1);
                            }}>
                            Медиапланы
                        </ColorButton>
                    </Grid>
                    <Grid item xs={6}>
                        <ColorButton
                            fullWidth
                            sx={{ backgroundColor: tab === 2 ? "rgba(210, 185, 25, 0.04)" : "" }}
                            onClick={() => {
                                setQuery({});
                                setTab(2);
                            }}>
                            Ссылки на публикации
                        </ColorButton>
                    </Grid>
                    <Grid item xs={6}>
                        <ColorButton
                            fullWidth
                            sx={{ backgroundColor: tab === 3 ? "rgba(210, 185, 25, 0.04)" : "" }}
                            onClick={() => {
                                setTab(3);
                            }}>
                            ФотоМатериалы
                        </ColorButton>
                    </Grid>
                    <Grid item xs={6}>
                        <ColorButton
                            fullWidth
                            sx={{ backgroundColor: tab === 4 ? "rgba(210, 185, 25, 0.04)" : "" }}
                            onClick={() => {
                                setQuery({ actual: 1 });
                                setTab(4);
                            }}>
                            Анонсы
                        </ColorButton>
                    </Grid>
                </Grid>
                <TabPanel index={tab === 4 ? 4 : tab === 0 ? 0 : 1} value={tab}>
                    <>
                        <TableContainer component={Paper} sx={{ marginBottom: "80px" }}>
                            <Table aria-label="equipment table" sx={{ "& td": { border: "none" } }}>
                                <TableHead sx={{ "& th": { fontSize: "16px", fontWeight: 700 } }}>
                                    <TableRow>
                                        <TableCell>Наименование</TableCell>
                                        <TableCell align="center">Планируемая дата</TableCell>
                                        <TableCell align="center">Статус</TableCell>
                                        <TableCell align="center">Ссылка</TableCell>
                                        <TableCell align="center"></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {posts?.map(post => (
                                        <TableRow key={post.id} sx={{ border: 0 }}>
                                            <TableCell sx={{ maxWidth: "250px", wordWrap: "break-word" }}>
                                                {post.title}
                                            </TableCell>
                                            <TableCell align="center">{getDateFormat(post?.date)}</TableCell>
                                            <TableCell align="center">
                                                {post.state ? "Проведен" : "Не проведен"}
                                            </TableCell>
                                            <TableCell sx={{ maxWidth: "250px", wordWrap: "break-word" }}>
                                                <Link href={post.url} underline="always">
                                                    {post.url}
                                                </Link>
                                            </TableCell>
                                            <TableCell align="center">
                                                {isOwner && (
                                                    <div className={"btnContainer"}>
                                                        <Button
                                                            variant="outlined"
                                                            fullWidth
                                                            onClick={() => {
                                                                postId === post.id && setShowModal(true);
                                                                setPostId(post.id);
                                                                setCurrentModalType(MODAL_TYPE.edit);
                                                            }}>
                                                            Изменить
                                                        </Button>
                                                        <Button
                                                            fullWidth
                                                            variant="outlined"
                                                            onClick={() => {
                                                                setShowModal(true);
                                                                setDeletePostId(post.id);
                                                                setCurrentModalType(MODAL_TYPE.delete);
                                                            }}>
                                                            Удалить
                                                        </Button>
                                                    </div>
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <div className={"posBR"}>
                            <div className={"paginationContainer"}>
                                <Pagination
                                    onChange={(index, qwerty) => setPagination({ ...pagination, current_page: qwerty })}
                                    page={pagination.current_page}
                                    count={pagination.last_page}
                                    shape="rounded"
                                />
                            </div>
                            {isOwner && (
                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        createForm.reset();
                                        setCurrentModalType(MODAL_TYPE.create);
                                        setShowModal(true);
                                    }}>
                                    Добавить
                                </Button>
                            )}
                        </div>
                    </>
                </TabPanel>
                <TabPanel index={2} value={tab}>
                    <TableContainer component={Paper} sx={{ marginBottom: "80px" }}>
                        <Table aria-label="equipment table" sx={{ "& td": { border: "none" } }}>
                            <TableHead sx={{ "& th": { fontSize: "16px", fontWeight: 700 } }}>
                                <TableRow>
                                    <TableCell>Ссылка</TableCell>
                                    <TableCell align="center">Мероприятие</TableCell>
                                    <TableCell align="center">Дата</TableCell>
                                    <TableCell align="center"></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {posts?.map(post => (
                                    <TableRow key={post.id} sx={{ border: 0 }}>
                                        <TableCell sx={{ maxWidth: "250px", wordWrap: "break-word" }}>
                                            <Link href={post.url} underline="always">
                                                {post.url}
                                            </Link>
                                        </TableCell>
                                        <TableCell sx={{ maxWidth: "250px", wordWrap: "break-word" }}>
                                            {post.title}
                                        </TableCell>
                                        <TableCell align="center">{getDateFormat(post.date)}</TableCell>
                                        <TableCell align="center">
                                            {isOwner && (
                                                <div className={"btnContainer"}>
                                                    <Button
                                                        variant="outlined"
                                                        fullWidth
                                                        onClick={() => {
                                                            postId === post.id && setShowModal(true);
                                                            setPostId(post.id);
                                                            setCurrentModalType(MODAL_TYPE.edit);
                                                        }}>
                                                        Мероприятие
                                                    </Button>
                                                </div>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TabPanel>
                <TabPanel index={3} value={tab}>
                    <Paper sx={{ p: 1 }}>
                        <ImageList sx={{ width: "100%", height: 450 }} cols={3} rowHeight={164}>
                            {(posts ?? [])
                                .reduce((acc, item) => {
                                    return [...acc, ...item?.photos?.map(el => ({ ...el, url: item.url }))];
                                }, [] as Array<Photo & { url?: string }>)
                                ?.map(item => {
                                    return (
                                        <ImageListItem key={item.id} component={LinkBehavior} to={item.url ?? ""}>
                                            <img src={`${BASE_IMG_URL}/${item.path}`} alt={item.name} loading="lazy" />
                                        </ImageListItem>
                                    );
                                })}
                        </ImageList>
                    </Paper>
                </TabPanel>
                <CustomSnackbar
                    openSnackbar={openSnackbar}
                    setOpenSnackbar={setOpenSnackbar}
                    notification={notification}
                />
                <Loader backDrop open={load} />
            </div>
            <Modal
                open={showModal}
                title={modalType[currentModalType]?.title}
                onClose={() => {
                    closeModal();
                }}
                onSubmit={modalType[currentModalType]?.onSubmit}>
                {modalType[currentModalType]?.content}
            </Modal>
        </>
    );
};

export default PostsPage;
